import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MembershipPluginsService } from '@common/membership/shared';
import { UiInputSelectButtonComponent } from '@common/ui/frontend-shared/input-selectbutton';
import { CoreFrontendSharedModule } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { MembershipRegistrationFacade, MembershipRegistrationState } from '../state';
import * as i0 from "@angular/core";
import * as i1 from "../state";
import * as i2 from "@common/membership/shared";
import * as i3 from "@angular/forms";
import * as i4 from "@angular/common";
function RegistrationTypeSelectionComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtext(2, "Wie sind Sie versichert?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ui-input-selectbutton", 0);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵlistener("onChange", function RegistrationTypeSelectionComponent_Conditional_0_Template_ui_input_selectbutton_onChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectType($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r1.selectablePluginOptions)("ngModel", i0.ɵɵpipeBind1(4, 2, ctx_r1.membershipType$));
  }
}
export let RegistrationTypeSelectionComponent = /*#__PURE__*/(() => {
  class RegistrationTypeSelectionComponent {
    constructor(registration, pluginsService, cd) {
      this.registration = registration;
      this.pluginsService = pluginsService;
      this.cd = cd;
      this.displayMode$ = inject(Store).select(MembershipRegistrationState.displayMode);
      this.membershipType$ = inject(Store).select(MembershipRegistrationState.membershipType);
      this.selectablePlugins = this.pluginsService.getPluginsList();
      this.selectablePluginOptions = this.selectablePlugins.map(plugin => {
        return {
          value: plugin.id,
          label: plugin.name
        };
      });
      this.pluginFormCompleted = formData => {
        this.registration.setFormData(formData);
        this.registration.confirmStep();
      };
      this.onSaveFormState = pluginFormStateInfo => {
        this.registration.setPluginFormState(pluginFormStateInfo);
      };
      this.onSelectType = event => {
        this.registration.setMembershipType(event.value);
      };
    }
    static {
      this.ɵfac = function RegistrationTypeSelectionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationTypeSelectionComponent)(i0.ɵɵdirectiveInject(i1.MembershipRegistrationFacade), i0.ɵɵdirectiveInject(i2.MembershipPluginsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RegistrationTypeSelectionComponent,
        selectors: [["membership-registration-type-selection"]],
        decls: 1,
        vars: 1,
        consts: [[3, "onChange", "options", "ngModel"]],
        template: function RegistrationTypeSelectionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, RegistrationTypeSelectionComponent_Conditional_0_Template, 5, 4, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.selectablePluginOptions.length > 1 ? 0 : -1);
          }
        },
        dependencies: [CommonModule, FormsModule, i3.NgControlStatus, i3.NgModel, CoreFrontendSharedModule, UiInputSelectButtonComponent, i4.AsyncPipe],
        styles: ["[_nghost-%COMP%]{margin:0 0 20px;display:block}p[_ngcontent-%COMP%]{margin:0 0 10px}\n\n/*# sourceMappingURL=registration-type-selection.component.ts-angular-inline--51.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return RegistrationTypeSelectionComponent;
})();